import { HttpContext, HttpContextToken } from "@angular/common/http";

export const USE_CC_TOKEN = new HttpContextToken<boolean>(() => false);
export const BYPASS_AUTH = new HttpContextToken<boolean>(() => false);
export const SKIP_HEADERS = new HttpContextToken<boolean>(() => false);
export const SKIP_ACCOUNT_ID = new HttpContextToken<boolean>(() => false);

export function useCCToken() {
    return new HttpContext().set(USE_CC_TOKEN, true);
}

export function byPassAuthorization() {
    return new HttpContext().set(BYPASS_AUTH, true);
}

export function skipHeaders() {
    return new HttpContext().set(SKIP_HEADERS, true);
}

export function skipAccountId() {
    return new HttpContext().set(SKIP_ACCOUNT_ID, true);
}